import Vue from 'vue'
import Router from 'vue-router'
import AsideApp from '@/views/layouts/AsideApp.vue'
import Login from '@/views/auth/Login.vue'
import PasswordReset from '@/views/auth/PasswordReset.vue'

import assignments from './assignments'
import riders from './riders'
import users from './users'
import horses from './horses'
import evaluations from './evaluations'
import ranking from './rankig'
import summary from './summary'
import dailywork from './dailywork'
import offdays from './offdays'
import reports from './reports'
import ironwork from './ironwork'
import viewers from './viewers'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        onlyGuest: true
      }
    },
    {
      path: '/password-reset',
      name: 'passwordReset',
      component: PasswordReset,
      meta: {
        onlyGuest: true
      }
    },
    {
      path: '/',
      name: 'root',
      component: AsideApp,
      meta: {
        authRequired: true
      },
      redirect: '/resumen',
      children: [
        ...summary,
        ...ranking,
        ...evaluations,
        ...horses,
        ...riders,
        ...assignments,
        ...dailywork,
        ...offdays,
        ...reports,
        ...ironwork,
        ...users,
        ...viewers
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
